module.exports = require("sanitize-html");


//////////////////
// WEBPACK FOOTER
// external "sanitize-html"
// module id = 592
// module chunks = 0